import React, { useState, useEffect } from "react";

export default function Intro() {

    return (
        <div style={{ maxWidth: 800, margin: "24px auto", fontFamily: "sans-serif" }}>
            <h2>The Nature of Code</h2>
            <p>
                I recieved <a href="https://natureofcode.com/"> the Nature of Code Book</a> from my Parents for Christmas (after I asked for it). I am going to try and post all of the exersizes that I do on this page to help motivate myself to finish it.
                You can see my progress by hitting the next button and see how it is going
            </p>
                
        </div>
    );
}